/**
 * DeSight Shopify X | v1.0.0
 * Loading Screen Component
 *
 * Enterprise-Level Ladescreen mit intelligenter Steuerung
 */

(function () {
  'use strict';

  /**
   * Loading Screen Manager
   */
  function initLoadingScreen() {
    const loadingScreen = document.getElementById('desight-loading-screen');

    if (!loadingScreen) {
      return;
    }

    // Get settings from data attributes
    const transition = loadingScreen.getAttribute('data-transition') || 'fade';
    const transitionDuration = parseInt(loadingScreen.getAttribute('data-transition-duration')) || 600;
    const minDuration = parseInt(loadingScreen.getAttribute('data-min-duration')) || 500;
    const maxDuration = parseInt(loadingScreen.getAttribute('data-max-duration')) || 5000;

    // Set CSS variable for transition duration
    loadingScreen.style.setProperty('--transition-duration', transitionDuration + 'ms');

    // Track loading state
    let startTime = Date.now();
    let isPageLoaded = false;
    let isMinDurationMet = false;
    let maxDurationTimeout = null;

    /**
     * Hide loading screen with transition
     */
    function hideLoadingScreen() {
      loadingScreen.classList.add('desight-loading-screen--hiding');

      setTimeout(function () {
        loadingScreen.classList.add('desight-loading-screen--hidden');
        loadingScreen.style.display = 'none';
        document.body.style.overflow = '';
      }, transitionDuration);
    }

    /**
     * Check if we can hide the loading screen
     */
    function checkAndHide() {
      if (isPageLoaded && isMinDurationMet) {
        hideLoadingScreen();
      }
    }

    /**
     * Update progress bar (if enabled)
     */
    function updateProgress(percentage) {
      const progressFill = loadingScreen.querySelector('.desight-progress__fill');
      const progressPercentage = loadingScreen.querySelector('.desight-progress__percentage');

      if (progressFill) {
        progressFill.style.width = percentage + '%';
      }

      if (progressPercentage) {
        progressPercentage.textContent = Math.round(percentage) + '%';
      }
    }

    /**
     * Simulate progress for progress bar animation
     */
    function simulateProgress() {
      const progressBar = loadingScreen.querySelector('.desight-progress');

      if (!progressBar) {
        return;
      }

      let progress = 0;
      const increment = 100 / (maxDuration / 100); // Update every 100ms

      const progressInterval = setInterval(function () {
        if (progress < 90) {
          progress += increment;
          updateProgress(progress);
        }

        if (isPageLoaded) {
          progress = 100;
          updateProgress(progress);
          clearInterval(progressInterval);
        }
      }, 100);
    }

    // Prevent body scroll while loading
    document.body.style.overflow = 'hidden';

    // Start progress simulation if progress bar is present
    simulateProgress();

    // Minimum duration timer
    setTimeout(function () {
      isMinDurationMet = true;
      checkAndHide();
    }, minDuration);

    // Maximum duration timer (fallback)
    maxDurationTimeout = setTimeout(function () {
      isPageLoaded = true;
      isMinDurationMet = true;
      hideLoadingScreen();
    }, maxDuration);

    // Check if page is already fully loaded
    if (document.readyState === 'complete') {
      isPageLoaded = true;
      updateProgress(100);
      checkAndHide();
    } else {
      // Page load event - wait for complete load
      window.addEventListener('load', function () {
        const loadTime = Date.now() - startTime;

        isPageLoaded = true;
        updateProgress(100);
        checkAndHide();
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoadingScreen);
  } else {
    initLoadingScreen();
  }

  // Export to global scope for external access
  window.DeSightLoadingScreen = {
    init: initLoadingScreen
  };

})();

